import React from "react";
import style from "css/workspace.module.css";
import Detailcommon from "./detailcommon";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function Hotdesk() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const HeaderInfo = [
    {
      id: 1,
      title: "전자 명패",
      txt: "자리이용자 이름 표시, 자율좌석제 이용 시 필요",
    },
    {
      id: 2,
      title: "개인용 화상장비 (neat. Frame)",
      txt: "회의 접속 시, 개별 참여 가능 / 개인 모니터로 접속 불필요",
    },
    {
      id: 3,
      title: "ZOOM PHONE",
      txt: "Zoom Phone에 QR코드로 체크인 시 업무 전화로 사용 가능",
    },
    {
      id: 4,
      title: "스마트 워크 플랫폼 (all Place)",
      txt: "자리 예약 및 체크인 / 체크아웃 / 실시간 현황 조회 가능",
    },
  ];

  const BodyHeader = (
    <div className={style.bodyTitle}>
      {!isMobile && !isTablet ? (
        <>
          <p>
            <font>Hot Desking</font>을 통해 사무실과 원격 근무 환경 간의 간격을
            줄이는 것을 목표로
          </p>
          <p>
            사무실의 다양한 공간을{" "}
            <font>유연하게 예약하고 사용할 수 있도록 설계</font> 되었습니다.
          </p>
        </>
      ) : (
        <>
          <p>
            <font>Hot Desking</font>을 통해 사무실과 원격 근무 환경 간의 간격을
            줄이는 것을 목표로 사무실의 다양한 공간을{" "}
            <font>유연하게 예약하고 사용할 수 있도록 설계</font> 되었습니다.
          </p>
          <p></p>
        </>
      )}
    </div>
  );
  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              {" "}
              <font>
                현장에서 좌석 예약 가능 하며, QR-Code를 활용하여 좌석예약 및
                체크인 / 아웃을 할 수
              </font>
              <font>
                있습니다. 다양한 디바이스와 연결하여 실시간으로 자원 사용 현황을
                조회/예약 할 수 있으며,
              </font>
              <font>
                직관적인 화면으로 사용자가 이용하기 쉽도록 설계되었습니다.
              </font>
            </>
          ) : (
            "현장에서 좌석 예약 가능 하며, QR-Code를 활용하여 좌석예약 및 체크인 / 아웃을 할 수 있습니다. \n다양한 디바이스와 연결하여 실시간으로 자원 사용 현황을 조회/예약 할 수 있으며, 직관적인 화면으로 사용자가 이용하기 쉽도록 설계되었습니다."
          )}
        </div>
      ),
      title: "좌석 예약 ( Desk Reservation )",
      img: "img/smartspace/hotdeskBody1.png",
      img_m: "img/smartspace/hotdeskBody1_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              {" "}
              <font>
                QR코드를 이용해 체크인 하면 정보가 사용자의 이름으로 변경 되며,
              </font>
              <font>
                PC/Mobile/전자명패/키오스크에서 연결된 사용자를 로그아웃하면
                체크아웃이 되며,
              </font>
              <font> 공석으로 변경되어 다른 사용자가 이용 가능합니다.</font>
            </>
          ) : (
            "QR코드를 이용해 체크인 하면 정보가 사용자의 이름으로 변경 되며, PC/Mobile/전자명패/키오스크에서 연결된 사용자를 로그아웃하면 체크아웃이 되며, 공석으로 변경되어 다른 사용자가 이용 가능합니다."
          )}
        </div>
      ),
      title: "QR코드 체크인 / 체크아웃 (QR Code)",
      img: "img/smartspace/hotdeskBody2.png",
      img_m: "img/smartspace/hotdeskBody2_m.png",
    },
  ];
  const BodyFooterTitle = (
    <div className={style.bodyFooterTitle}>
      {!isMobile && !isTablet ? (
        <>
          <p>
            리브테크놀로지의 <font>자율좌석 시스템</font>을 통해
          </p>
          <p>
            <font>스마트한 공간 활용</font>을 실현해보세요
          </p>
        </>
      ) : (
        <>
          <p>
            리브테크놀로지의
            <br />
            <font>자율좌석 시스템</font>을 통해
          </p>
          <p>
            <font>스마트한 공간 활용</font>을 실현해보세요
          </p>
        </>
      )}
    </div>
  );
  const BodyFooter = [
    {
      id: 1,
      txt: "자율좌석제는 고정 좌석을 줄이고, 직원들이 필요에 따라 좌석을 선택할 수있도록 하여 공간 활용도를 극대화합니다. 이를 통해 보다 유연한 사무실 구조를 만들고, 불필요한 공간 낭비를 줄여 효율적으로 공간을 관리할 수있습니다.",
      title: "공간 활용의 최적화",
    },
    {
      id: 2,
      txt: "직원들이 팀 프로젝트나 협업이 필요한 부서 근처에서 자율적으로 좌석을 선택할 수 있어, 업무에 필요한 소통이 더욱 원활해 집니다. 자율좌석제를 통해 부서 간 벽을 허물고, 다양한 팀 간의 상호작용을 촉진하여 협업과 창의성을 높입니다.",
      title: "팀 간 협업 증대",
    },
    {
      id: 3,
      txt: "자율좌석제는 직원들이 매일 다른 환경에서 일할 수 있는 선택권을 제공하여, 단조로움을 줄이고 더 큰 만족감을 제공합니다. 개방된 공간, 조용한 공간, 협업 공간 등 상황에 맞게 좌석을 선택할 수 있어 업무 집중도와 효율성을 높이는 데 도움이 됩니다.",
      title: "업무 환경의 유연성 제공",
    },
  ];
  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      자율 좌석 시스템 <font>구성 환경</font>
    </div>
  );
  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_board_pro.png",
      title: "자율좌석 현황 모니터 neat. board Pro",
      txt: "대형 화면과 올인원 화상회의 기능을 갖춘 Neat Board는 팀 회의 및 협업을 위한 최적의 디바이스 입니다. 고해상도 터치 스크린과 내장 카메라를 통해 생동감 있는 회의 경험을 제공합니다.",
      onClick: () => showDrawer("boardpro"),
    },
    {
      id: 3,
      img: "img/device/nameplate/swiper_name_plate.png",
      title: "전자명패",
      // txt: "컴팩트한 사이즈와 고성능 카메라를 탑재한 Neat Frame은 작은 공간에서도 깔끔하게 배치할 수 있어 유연한 근무 환경을 지원합니다.",
      txt: "자율좌석제와 연동된 전자명패는 좌석의 사용 현황과 예약 정보를\n실시간으로 표시하여, 사용자가 자리 배치를 손쉽게 파악할 수 있도록\n도와줍니다. 직원들의 자율적인 좌석 선택과 관리를 지원하는 스마트\n솔루션입니다.",
      onClick: () => showDrawer("nameplate"),
    },
    {
      id: 4,
      img: "img/device/neat/swiper_frame.png",
      title: "자율좌석 화상장비 neat. frame",
      // txt: "컴팩트한 사이즈와 고성능 카메라를 탑재한 Neat Frame은 작은 공간에서도 깔끔하게 배치할 수 있어 유연한 근무 환경을 지원합니다.",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },

    // {
    //   id: 5,
    //   img: "img/device/neat/swiper_frame.png",
    //   title: "Zoom Phone",
    //   // txt: "컴팩트한 사이즈와 고성능 카메라를 탑재한 Neat Frame은 작은 공간에서도 깔끔하게 배치할 수 있어 유연한 근무 환경을 지원합니다.",
    //   txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
    //   onClick: () => showDrawer("zoomphone"),
    // },
    // {
    //   id: 5,
    //   img: "img/smartspace/composeImg1.png",
    //   title: "스마트 워크 플랫폼 all Place",
    //   txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
    //   link: "smart-space/work/platform",
    // },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      }),
    );
    document.querySelector("#page_header").style.height = "0";
  };
  return (
    <>
      <SEOMeta
        title="자율 좌석제, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 자율 좌석제"
        keywords="riv, riv Technology, neat, 스마트 회의실, 화상회의, 자율 좌석제, 핫 데스킹"
      />
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.commonHeader}>
          <div className={style.CommonHeaderTxt}>
            <p>Hot Desking</p>
            <p>자율 좌석 시스템</p>
            <p>
              {!isMobile && !isTablet ? (
                <>
                  <font>자율좌석 시스템은 고정 좌석을 지정하지 않고</font>
                  <font>
                    각자 자리를 선택하여 업무를 진행할 수 있는 시스템입니다.
                  </font>
                </>
              ) : (
                <>
                  <font>자율좌석 시스템은{"\n"}고정 좌석을 지정하지 않고</font>
                  <font>
                    각자 자리를 선택하여{"\n"}업무를 진행할 수 있는
                    시스템입니다.
                  </font>
                </>
              )}
            </p>
          </div>
          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/hotdeskHeader.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/hotdeskHeader_m.png`
            }
          />
          <div className={style.hotdeskHeaderInfoWrap}>
            <p>
              <font>
                스마트 워크 플랫폼 · 좌석 예약 현황 모니터 · QR코드 · 전자명패
              </font>
              로 <br /> 구성되어 있으며, 기업의 업무활동에 맞도록 선택하여
              구성할 수 있습니다.
            </p>
            <div>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/hotdeskHeaderInfo.png`
                    : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/hotdeskHeaderInfo_m.png`
                }
              />
              <div className={style.hotdeskHeaderInfoTxt}>
                {HeaderInfo.map((info) => (
                  <div className={style.hotdeskHeaderInfoCard}>
                    <p>
                      <font>{info.id}</font>
                      <font>{info.title}</font>
                    </p>
                    <p>
                      {!isMobile && !isTablet ? <font /> : <></>}
                      <font>{info.txt}</font>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Detailcommon
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          bodyFooter={BodyFooter}
          compose={Compose}
          bodyFooterTitle={BodyFooterTitle}
          composeHeader={ComposeHeader}
        />
        <Questions />
      </div>
    </>
  );
}

export default Hotdesk;
